<template>
  <a-modal
      v-model:open="modalContent.visible"
      :title="modalContent.title"
      centered
      style="max-width: 85%; max-height: 80%;"
  >

    <a-list item-layout="vertical" size="middle" :data-source="emailContacts">
      <template #renderItem="{ item }">
        <a-list-item key="item.id">
          <template #extra>
            <a-flex justify="center" align="center" vertical class="full">
              <a-button :icon="h(EditOutlined)" type="primary" @click="sendMail(item.upn)">
                Ask for Help
              </a-button>
            </a-flex>
          </template>
          <a-list-item-meta :description="item.desc">
            <template #title>
              <a @click="sendMail(item.upn)">{{ item.title }}</a>
            </template>
            <template #description>
              <a-typography-link @click="sendMail(item.upn)" type="secondary">
                {{ item.name }}
                <br/>
                {{ item.email }}
              </a-typography-link>
            </template>
          </a-list-item-meta>
        </a-list-item>
      </template>
    </a-list>
    <template #footer>
      <a-button type="default" @click="modalContent.visible = false;">Close</a-button>
    </template>
  </a-modal>

  <div class="background">
    <img class="background-img" src="@/assets/bg.jpg" alt="background">
  </div>

  <a-flex justify="center" align="center" vertical class="full">
    <div style="overflow-y: auto; overflow-x: hidden; width: 80%; max-width: 1000px;">
      <a-typography-title class="title" align="center">
        MFA Contact Information
      </a-typography-title>
      <contact-card-grid :data="contactMethods"
                         :grid="{gutter: 16, xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2}"
                         @show-modal="showModal">
        <template v-slot:card="items">
          <contact-card :item="items.item" @showModal="showModal" @launchTeams="launchTeams"/>
        </template>
      </contact-card-grid>
    </div>
  </a-flex>
</template>

<script>
import ContactCardGrid from "@/components/CardGrid.vue";
import ContactCard from "@/components/ContactCard.vue";
import {defineComponent, h} from "vue";
import {EditOutlined} from "@ant-design/icons-vue";

export default defineComponent({
  components: {
    ContactCardGrid,
    ContactCard,
  },
  data: function () {
    return {
      teamsLink: "",
      tenantId: "",
      topicPrefix: "",
      teamsContacts: [],
      emailContacts: [],
      modalContent: {
        title: "Mail List",
        visible: false,
        data: []
      },
      contactMethods: []
    }
  },
  created: function () {
    this.updateIndex();
  },
  methods: {
    h,
    EditOutlined,
    updateIndex() {
      fetch(process.env.BASE_URL + "contact.json").then(res => {
        res.json().then(index => {
          this.tenantId = index["tenantId"];
          this.topicPrefix = index["topicPrefix"];
          this.teamsContacts = index["contacts"]
              .filter(el => el["teams"])
              .sort((a, b) => a.id - b.id);
          this.emailContacts = index["contacts"]
              .filter(el => el["email"])
              .sort((a, b) => a.id - b.id)
              .map((el, idx) => {
                return {
                  "id": idx,
                  "title": el["userTitle"],
                  "name": el["name"],
                  "email": `<${el["upn"]}>`,
                  "upn": el["upn"],
                  "url": this.getMailToLink(el["upn"], index["contacts"]),
                }
              });
          this.contactMethods = [
            {
              "id": 1,
              "title": "Teams",
              "url": this.getTeamsLink(),
              "icon": "/img/teams.png",
              "filename": "",
              "desc": "Chat directly via Microsoft Teams",
              "text": "Chat with Teams"
            },
            {
              "id": 2,
              "title": "Email",
              "icon": "/img/email.png",
              "filename": "",
              "desc": "Ask for support with Email",
              "content": [],
              "text": "Show Emails"
            }
          ]
        });
      });
    },
    showModal(content) {
      this.modalContent.data = content;
      this.modalContent.visible = true;
    },
    today() {
      const t = new Date();

      // YYYY-MM-DD
      const date = t.toLocaleDateString("en-CA", {timeZone: "Asia/Baghdad"}).replace(/-/g, "");
      // 24h HH:MM
      const time = t.toLocaleTimeString("en-GB", {
        timeZone: "Asia/Baghdad",
        hour: "numeric",
        minute: "numeric"
      }).replace(/:/g, "");

      return `${date}${time}`;
    },
    getTeamsLink() {
      return `https://teams.microsoft.com/l/chat/0/0?tenantId=${this.tenantId}&users=${encodeURIComponent(`${this.teamsContacts.map(el => el["upn"]).join(",")}`)}&topicName=${encodeURIComponent(`${this.topicPrefix} - ${this.today()}`)}`
    },
    getMailToLink(to) {
      return `mailto:${to}?subject=${encodeURIComponent(`${this.topicPrefix} - ${this.today()}`)}&cc=${this.emailContacts.map(el => el["upn"]).filter(el => el !== to).join("%3B")}`
    },
    sendMail(upn) {
      window.location.href = this.getMailToLink(upn);
    },
    launchTeams() {
      window.location.href = this.getTeamsLink();
    }
  }
});

</script>

<style scoped>
.background {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
}

.background-img {
  width: 100%;
  height: 100%;
}

.full {
  height: 100%;
  width: 100%;
}

.title {
  margin-bottom: 50px;
  color: whitesmoke;
}
</style>